import React, { useContext, useEffect, useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import api from './../api.js';
import { site_url, nodata } from "./../config.js";
import { AuthContext } from './../AuthContext';
import { Player } from '@lottiefiles/react-lottie-player';
import './style.css';
const CanvasJSChart = CanvasJSReact.CanvasJSChart;
const Index = () => {
    const { user, refreshUser,fulluser, vendordetails } = useContext(AuthContext);

    const [categorydata, setcategorydata] = useState([]);
    useEffect(() => {
        const productcategory = async () => {
            try {
                const userId = user || fulluser?.id;
                if (!userId) return;

                const response = await api.get('/vendor/monthreport/' + userId);

                if (response.data.status == 'success') {
                    setcategorydata(response.data);
                }
            } catch (error) {
                console.error('Error fetching product category:', error);
            }
        }

        productcategory();
    }, [user, fulluser])
    const options = {
        exportEnabled: false,
        animationEnabled: true,
        theme: 'light1',
        data: [{
            type: "pie",
            startAngle: 75,
            toolTipContent: "<b>{label}</b>: {y}%",
            showInLegend: true,
            legendText: "{label}",
            indexLabelFontSize: 16,
            indexLabel: "{label} - {y}%",
            dataPoints: categorydata.monthdata
        }]
    };

    // Safety check - don't render if user data is not available
    if (!user && !fulluser) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div>

            {categorydata.total <= 0 ? (
                <Player
                    src={nodata}
                    className="player"
                    loop
                    autoplay
                    style={{ height: '100%', width: '300px' }}
                />
            ) : (
                <div>

                    <CanvasJSChart options={options} />

                </div>
            )}
        </div>
    );
};
export default Index;
